let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3xp2K")).then(() => parcelRequire('iGd9n'));